// Controls whether the client portal is publicly accessible.
// Set to false to hide all portal entry points from the public site.
// All portal code, routes, and infrastructure remain intact.
// This value is overridden at runtime by the app_settings key "portal_enabled"
// when loaded via the usePortalConfig hook.
export const PORTAL_ENABLED_DEFAULT = false;
